/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//iconos
import {
  BoltIcon,
  WrenchScrewdriverIcon,
  PaintBrushIcon,
  BeakerIcon,
  SparklesIcon,
  KeyIcon,
  WrenchIcon,

} from "@heroicons/react/24/solid";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper/modules";

// @components
import Modal from "../../components/Modals/Modal";
import ServicesHero from "./components/ServicesHero";
import MarketplaceHero from "./components/MarketplaceHero";
import TopServicesHero from "./components/TopServicesHero";
import JoinCommunity from "./components/JoinCommunityHero";
import AppDownloadHero from "./components/AppDownloadHero";
import ContactHero from "./components/ContactHero";
import ServiceSearchField from "./components/ServiceSearchComponent";

// @config
import routesConfig from "../../config/routes.config";

// @store
import { useSpinnerStore } from "../../store/useSpinnerStore";
import useAuthStore from "../../store/useAuthStore";
import { useCompanyStore } from "../../store/useCompanyStore";
import useCategoryStore from "../../store/useCategoryStore";

// @types
import { UserRole } from "../../types/auth.types";
import { SubCategory } from "../../types/category.types";

// @image
import fondo from "../../assets/images/Fondo_landing.jpg";

const LandingPage = () => {
  const { t } = useTranslation();

  const { openSpinner } = useSpinnerStore();
  const { roleList } = useAuthStore();
  const { getProfessional, getUser, data, userData } = useCompanyStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const { categoryHierarchy, fetchCategoriesHierarchy } =
    useCategoryStore();

  useEffect(() => {
    fetchCategoriesHierarchy();
  }, [fetchCategoriesHierarchy]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  console.log(categoryHierarchy)

  const getUserByType = () => {
    if (!roleList?.length) return;
    if (roleList?.includes(UserRole.PROFESSIONAL)) {
      if (data !== null) return;
      return getDataForUser(true);
    }
    if (roleList?.includes(UserRole.USER)) {
      if (userData !== null) return;
      return getDataForUser(false);
    }
    return;
  };

  const getDataForUser = async (isCompany: boolean) => {
    openSpinner(true);
    try {
      isCompany ? await getProfessional() : await getUser();
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  };

  useEffect(() => {
    getUserByType();
  }, []);

  const categoryId = categoryHierarchy?.[0]?.categoryId ?? "";

  const handleClick = (serviceId: SubCategory) => {
    if (!categoryId || !serviceId) return;
    navigate(
      routesConfig.serviceForm
        .replace(":categoryId", categoryId)
        .replace(":subCategoryId", serviceId.subCategoryId),
      { state: { urlImg: serviceId?.urlImage } }
    );
  };


  const iconMapping: { [key: string]: JSX.Element } = {
    Electricidad: <BoltIcon className="!h-8 !w-8 text-textBrand" />,
    Jardinería: <BeakerIcon className="!h-8 !w-8 text-textBrand" />,
    Plomería: <WrenchScrewdriverIcon className="!h-8 !w-8 text-textBrand" />,
    Pintura: <PaintBrushIcon className="!h-8 !w-8 text-textBrand" />,
    Limpieza: <SparklesIcon className="!h-8 !w-8 text-textBrand" />,
    Cerrajería: <KeyIcon className="!h-8 !w-8 text-textBrand" />,
    "Mantenimiento electrodomesticos": <WrenchIcon className="!h-8 !w-8 text-textBrand" />,
  };



  return (
    <div className="">
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} title={t("loginPage.underRepair")}>
        <p className="text-[14px] font-medium mt-6">{t("loginPage.textModal")}</p>
      </Modal>
      {/* Portada */}
      <div className="h-[calc(100vh-150px)] flex flex-col items-center">
        <img
          className="absolute top-0 left-0 w-full h-screen object-cover object-[center_0%] -z-10" // 👈 Aquí el truco (-z-10)
          src={fondo}
          alt=""
        />
        {/* Barra de búsqueda */}
        <div className="relative mt-1 mx-auto lg:w-[1000px] z-10">
          <ServiceSearchField />
        </div>

        {/* Contenido */}
        <div className="w-full justify-start items-start mt-24">
          <div className="text-left lg:w-[46%] w-[70%] z-10 lg:pl-10 pl-6">
            {" "}
            {/* 👈 Asegurar que el contenido esté sobre la imagen */}
            <h1 className="lg:text-[50px] text-[32px] text-textBrand font-semibold leading-[60px]">
              Accede a una amplia gama de servicios en un solo lugar
            </h1>
            <p className="mt-4 text-lg text-gray-700">
              Encuentra el servicio que necesitas con facilidad.
            </p>
          </div>
        </div>

        <div className="w-full flex justify-center lg:px-10 px-4 absolute bottom-[30px]">
          {/* Diseño GRID en pantallas grandes */}
          <div className="hidden md:grid grid-cols-3 lg:grid-cols-9 gap-12 relative">
            {categoryHierarchy?.[0]?.subCategories?.map(
              (subCategory, index) => (
                <div
                  key={subCategory.subCategoryId || index}
                  onClick={() => handleClick(subCategory)}
                  className="w-32 h-32 flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow-md cursor-pointer transition-transform hover:scale-105"
                >
                  {/* Ícono */}
                  {iconMapping[subCategory.name] || <WrenchIcon className="w-12 h-12 text-[#F97068]" />}

                  {/* Nombre de la subcategoría (truncado si es largo) */}
                  <p className="mt-2 text-sm font-semibold text-gray-700 truncate w-full text-center">
                    {subCategory.name}
                  </p>
                </div>
              )
            )}
          </div>

          {/* Slider en móviles */}
          <div className="md:hidden w-full">
            <Swiper
              slidesPerView={3}
              spaceBetween={10}
              freeMode={true}
              pagination={{ clickable: true }}
              modules={[FreeMode, Pagination]}
              className="w-full pb-6"
            >
              {categoryHierarchy?.[0]?.subCategories?.map(
                (subCategory, index) => (
                  <SwiperSlide key={subCategory.subCategoryId || index}>
                    <div
                      onClick={() => handleClick(subCategory)}
                      className="w-28 h-28 flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow-md cursor-pointer transition-transform hover:scale-105"
                    >
                      {iconMapping[subCategory.name] || (
                        <WrenchScrewdriverIcon className="w-12 h-12 text-[#F97068]" />
                      )}
                      <p className="mt-2 text-sm font-semibold text-gray-700 truncate w-full text-center">
                        {subCategory.name}
                      </p>
                    </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
            {/* Paginación dentro de un contenedor relativo */}
            <div className="absolute bottom-0 w-full flex justify-center">
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Imagen de fondo */}

      {/* Resto de la página */}
      <div className="flex flex-col gap-0 xl:gap-2 px-6 z-10 relative mt-[80px]">
        {/* <CategoriesSlider /> */}
        <ServicesHero />
        <TopServicesHero onButtonClick={handleOpenModal} />
        <MarketplaceHero />
        <JoinCommunity onJoinClick={handleOpenModal} />
        <AppDownloadHero onButtonClick={handleOpenModal} />
        <ContactHero />
      </div>
    </div>
  );
};

export default LandingPage;
